import React from 'react';
import { Link } from 'react-router-dom';

const RegistrationSuccess = () => {
  return (
    <div>
      <h2>Registration Successful!</h2>
      <p>Thank you for subscribing to our Salon Management System.</p>
      <p>Your account is now active. You can start using our services.</p>
      <Link to="/login">Proceed to Login</Link>
    </div>
  );
};

export default RegistrationSuccess;